var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"detail-link btn-primary",attrs:{"to":("/inspection/" + _vm.hgFolderId)}},[_vm._v(" Inspection Details ")])}
var staticRenderFns = []

export { render, staticRenderFns }